import axios from 'axios';
import Environment from "../utils/Environment";

export interface FileMetaDataDTO {
    fileName: string;
    status: string;
    createdUser: string;
    createTs: string;
}

export interface AuditFetchResponse {
    fileMetaDataList: FileMetaDataDTO[];
    tabType: string;
    successCount: number;
    partialProcessCount: number;
    errorCount: number;
    totalCount: number;
}

export interface FetchCsvFileItem {
    applicationName: string;
    filename: string;
    status: string;
}

export interface FetchCsvFilesBatchRequest {
    items: FetchCsvFileItem[];
}

const getCount = async (selectedDC: string, selectedApp: string, selectedInterval: string, setIsLoading: (value: boolean) => void, setCount: (value: AuditFetchResponse) => void) => {
    const countAPI = `${Environment.getDashboardAPI()}/${selectedDC}/${selectedApp}/${selectedInterval}`;
    setIsLoading(true);
    try {
        const response = await axios.get(countAPI || '');
        if (response.status === 200) {
            setCount(response.data);
        }
    }
    catch (err: any) {
        console.log('Error:', err);
    }
    finally {
        setIsLoading(false);
    }
};

const fetchCsvFiles = async (dcId: string, request: FetchCsvFilesBatchRequest) => {
    const apiUrl = Environment.getFetchCsvFilesAPI();
    try {
        const response = await axios.post(apiUrl, request, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: { dcId }
        });
        if (response.status === 200) {
            // Assuming the backend returns an array of CsvFileResponse with content as base64 string
            const csvFiles: { fileName: string; content: string }[] = response.data;

            // Download files sequentially with delay to avoid browser limitations
            for (let i = 0; i < csvFiles.length; i++) {
                const file = csvFiles[i];

                // Decode base64 content to byte array
                const byteCharacters = atob(file.content);
                const byteNumbers = new Array(byteCharacters.length);
                for (let j = 0; j < byteCharacters.length; j++) {
                    byteNumbers[j] = byteCharacters.charCodeAt(j);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // Create blob with CSV MIME type
                const blob = new Blob([byteArray], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', file.fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Add delay between downloads to prevent browser from blocking subsequent downloads
                if (i < csvFiles.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 500)); // 500ms delay
                }
            }
        }
    } catch (err: any) {
        console.log('Error fetching CSV:', err);
    }
};

export { fetchCsvFiles };
export default getCount;